<template>
<!-- THIS WILL UTILISE A 'FULLSCREEN' DIALOG (LOOK ON VUETIFY COMPONENT DOCS TO UNDERSTAND) -->
    <v-card>
        <v-card v-if="localTreatment">
            <v-toolbar v-if="showToolbar" dark color="primary">
                <v-btn icon dark @click="dialogClosed()">
                <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>View Treatment Information</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn v-if="uid===localTreatment.owner" dark text @click="editTreatment()">Edit</v-btn>
                </v-toolbar-items>
                <v-toolbar-items>
                    <v-btn icon v-if="uid===localTreatment.owner" dark text @click="deleteTreatment()"><v-icon>mdi-delete</v-icon></v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card
            class="overflow-y-auto overflow-x-hidden"
            height="93vh"
            >
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-card flat>
                                    <v-carousel
                                    cycle
                                    height="400"
                                    hide-delimiter-background
                                    show-arrows-on-hover
                                    >
                                    <v-carousel-item
                                        v-for="(image, i) in getCurrentImages"
                                        :key="i"
                                    >
                                        <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-img
                                            contain
                                            :aspect-ratio="16/9"
                                            :src="image"
                                            :lazy-src="require('./../../../assets/ViewTreatmentScreen/imageIcon.png')"                                    
                                            >
                                                <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>
                                        </v-row>
                                    </v-carousel-item>  
                                    </v-carousel>
                                    <v-row>
                                        <v-col cols="12" md="10">
                                            <v-card-title>By  <b color="primary" @click="viewUserProfile(localTreatment.owner)"> {{localTreatment.ownerName}}</b></v-card-title>
                                            <v-card-subtitle>Created on {{localTreatment.dateAdded}}</v-card-subtitle>
                                            <v-card-subtitle>Last Modified on {{localTreatment.lastModified}}</v-card-subtitle>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <vote-control 
                                            :parentItem="{id: localTreatmentId, data: localTreatment}" 
                                            :commentMode="false" 
                                            :commentItem="null" 
                                            ></vote-control>
                                        </v-col>
                                    </v-row>                        
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-card height="100%" overflow-y="auto">
                                <v-card color="grey lighten-3">
                                    <v-card-title>{{localTreatment.title}}                         
                                        <v-card v-if="hasCase"
                                        color="#385F73"
                                        dark
                                        class="d-inline-block mx-auto"
                                        >
                                            <v-card-subtitle @click="viewCases()" class="pa-1">Part of Case</v-card-subtitle>
                                        </v-card>
                                        <v-icon v-if="!localTreatment.public" color="primary" class="pl-3">mdi-eye</v-icon>
                                    </v-card-title> 
                                </v-card>
                                
                                    <v-card-subtitle>
                                        <span class="display: inline-block" v-for="category in localTreatment.category" :key="category">
                                            <span class="primary--text" @click="viewCategoryTreatments(category)"> {{category}} | </span>
                                        </span>
                                    </v-card-subtitle>
                                <v-card-text> {{localTreatment.description}}</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="12">
                            <v-card height="100%">
                                <v-card-text> {{localTreatment.notes}}</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <comments-control 
                        :comments="localTreatment.comments" 
                        :parentId="localTreatmentId" 
                        parentType="treatment"
                        @updateComments="updateComments()"
                        ></comments-control>
                    </v-row>
                </v-container>
            </v-card>

            <!-- EDIT TREATMENT DIALOG -->
            <v-dialog v-model="editTreatmentDialog" persistent max-width="800px">
                <AddTreatmentPopup
                v-on:dialogClosed="closeEditTreatment()"
                label="Edit Treatment"
                :editMode="true"
                :originalTreatment="currentShownTreatment"></AddTreatmentPopup>
            </v-dialog>

            <v-dialog v-model="quickCategoryDialog">
                <QuickTreatmentCategoryPopup :category="currentSelectedCategory" :userDb="this.$route.params.userDb"></QuickTreatmentCategoryPopup>
            </v-dialog>

            <v-dialog v-if="hasCase" v-model="quickTreatmentCaseDialog">
                <QuickTreatmentCasePopup :caseIds="localTreatment.case.parentCases" :userDb="this.$route.params.userDb"></QuickTreatmentCasePopup>
            </v-dialog>

             <!-- VIEW PROFILE DIALOG -->
            <v-dialog v-model="viewProfileDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
                <profile-screen
                v-if="viewProfileDialog"
                v-on:dialogClosed="closeViewProfile()"
                :user="currentViewedUser"
                :label="currentViewedUser.displayname"
                :myProfile="false">
                </profile-screen>
            </v-dialog>
        </v-card>
        <v-progress-circular v-if="!localTreatment" indeterminate color="primary"></v-progress-circular>
    </v-card>
</template>

<script>
import AddTreatmentPopup from './../Popups/AddTreatmentPopup.vue'
import VoteControl from './../Voting/VoteControl.vue';
import CommentsControl from './../Comments/CommentsControl.vue';
import QuickTreatmentCategoryPopup from './../Category/QuickTreatmentCategoryPopup.vue';
import QuickTreatmentCasePopup from './../../Cases/Popups/QuickTreatmentCasePopup.vue';
import ProfileScreen from './../../Management/ProfileScreen.vue';
import TreatmentDataService from './../../../services/treatmentDataService.js';
import UserDataService from './../../../services/userDataService.js';
import swal from 'sweetalert2';
import Toast from './../../../plugins/customToast.js';

export default {
    name: 'viewTreatmentScreenPopup',
    components: {
        AddTreatmentPopup,
        VoteControl, 
        CommentsControl,
        QuickTreatmentCategoryPopup,
        QuickTreatmentCasePopup,
        ProfileScreen
    },
    props: {
        treatment: Object,
        treatmentId: String,
        uid: String,
        showToolbar: Boolean
    },
     beforeCreate() {
        this.$options.components.ProfileScreen = require('./../../Management/ProfileScreen.vue').default
    },
    mounted() {
        if (this.treatment){
            this.localTreatment = this.treatment;
            this.localTreatmentId = this.treatmentId;
        }
        this.treatmentService = new TreatmentDataService(this.$route.params.userDb);
        this.userDataService = new UserDataService();
    },
    watch: {
        treatment: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                if (val !== null){
                    this.localTreatment = this.treatment;
                    this.localTreatmentId = this.treatmentId;
                }
            }
        }
    },
    methods: {      
      saveTreatment(){
       
      },
      editTreatment(){
        if (this.localTreatmentId != null) {
            this.currentShownTreatment = { id: this.localTreatmentId, data: this.localTreatment };
            console.log("Editing Treatment Item: " + this.localTreatment.title + " by " + this.localTreatment.ownerName) // eslint-disable-line no-console
            this.editTreatmentDialog = true;
        }
      },
      deleteTreatment() {
          //Swal event in here
          swal.fire({
            title: 'Are you sure you wish to delete the treatment?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm'
            }).then((result) => {
                if (result.value) {
                    if (this.localTreatmentId != null) {
                    this.treatmentService.deleteTreatmentById(this.localTreatmentId);
                    swal.fire(
                    'Deleted!',
                    `Your ${this.localTreatment.title} treatment has been deleted.`,
                    'success'
                    )
                    }
                }
            })
        },
      closeEditTreatment() {
        this.editTreatmentDialog = false;
        //Really this must then update the treatment list we just visited
        this.reloadTreatment();
      },
      dialogClosed(){
        //Emit so that the parent call knows that the dialog has closed
        this.$emit("dialogClosed");
      },
      resetDialog(){
        //Function than can be called on completion, close and load to reset the dialog
        //Clear the current treatment images

      },
      updateComments(){
        //Get the new comments by calling a 'reloadTreatment'
        this.reloadTreatment();
      },
      viewCategoryTreatments(category) {
        if (category != null) {
            this.currentSelectedCategory = category;
            console.log("Viewing other treatments of the following category type: " + this.currentSelectedCategory) // eslint-disable-line no-console
            this.quickCategoryDialog = true;
        }
      },
      closeCategoryTreatments(){
        this.quickCategoryDialog = false;
      },
      viewCases(){
          console.log("Viewing other cases that this treatment is a part of: " + this.localTreatment.case.parentCases) // eslint-disable-line no-console
          this.quickTreatmentCaseDialog = true;
      },
      async viewUserProfile(profileId){
        var that = this;
        this.userDataService.searchFirebaseByUserId(profileId)
        .then(function (result) {
            if (result !== null){
                //If call was successful for user, show their profile page
                console.log("viewing user profile: " + result); //eslint-disable-line
                that.currentViewedUser = result;
                that.viewProfileDialog = true;
            } else {
                Toast.fire({  icon: 'error',  title: `Cannot currently view user profile`});
            }            
        }).catch(function (error) {
            Toast.fire({  icon: 'error',  title: `Cannot currently view user profile: ${error}`});
        });        
      },
      closeViewProfile(){
        this.currentViewedUser = {};
        this.viewProfileDialog = false;
      },
      async reloadTreatment(){
          //Reload the treatment from firebase to update it after a change has been made, 
          //then hopefully those changes will take place at the levels below
          var result = await this.treatmentService.searchFirebaseById('treatments', this.localTreatmentId);

          //Set our new values
          this.localTreatmentId = result.id;
          this.localTreatment = result.data;
      },    
    },
    computed: {
        hasCase(){
            //This may need handling in a better way
            if (this.localTreatment.case){
                if (this.localTreatment.case.value){
                    return true;
                }
            }
            return false;
        },
        getCurrentCategories(){
            var categories = this.localTreatment.category;

            if (categories.length > 0){
                var categoryString;
                categories.forEach(function (category){
                    if (categoryString) {
                        categoryString = categoryString  + ", " + category;
                    } else {
                        categoryString = category;
                    }                    
                })
                return categoryString;
            } else {
                return 'Not Selected';
            }
        },
        getCurrentImages(){
            if (this.localTreatment && this.localTreatment.images){
                return this.localTreatment.images;
            }
            return [];
        }
    },
    data: () => ({
      treatmentImages: [],
      showTreatmentTooltip: false,
      showPrivateTooltip: false,
      editTreatmentDialog: false,
      currentShownTreatment: {},
      localTreatment: {},
      localTreatmentId: "",
      treatmentService: {},
      currentSelectedCategory: "",
      quickCategoryDialog: false,
      userDataService: {},
      currentViewedUser: {},
      viewProfileDialog: false,
      quickTreatmentCaseDialog: false
    })
}
</script>